import React from 'react';
import { useGraph, useGraphVariables, useModel, useRenderer } from '../../hooks';
import GraphContainer from './GraphContainer';
import GraphControls from './GraphControls';
import GraphInformation from './GraphInformation';
import GraphLegend from './GraphLegend';
import GraphSearch from './GraphSearch';
import ToolBox from './ToolBox';
import './index.scss';
export default function BasemapView() {
    var graph = useGraph();
    var model = useModel();
    var variables = useGraphVariables();
    var renderer = useRenderer()[0];
    if (!graph || !variables)
        return null;
    return (React.createElement("div", { className: "Basemap container-fluid" },
        React.createElement(ToolBox, null),
        React.createElement(GraphContainer, { graph: graph, nodeColor: variables.nodeColor, nodeSize: variables.nodeSize, nodeLabel: variables.nodeLabel, edgeColor: variables.edgeColor, edgeSize: variables.edgeSize, labelDensity: variables.labelDensity }),
        renderer && React.createElement(GraphControls, { renderer: renderer }),
        renderer && (React.createElement(GraphSearch, { renderer: renderer, graph: graph, targetAttribute: variables.nodeLabel })),
        React.createElement(GraphLegend, { attribute: variables.nodeColor, graphHasTitle: graph.hasAttribute('title') }),
        React.createElement(GraphInformation, { graph: graph, weighted: model.weighted })));
}
